<template>
    <el-dialog v-dialogDrag :title="title" :visible.sync="show" width="800px">
        <div class="selector-actions">
            <div class="selector-actions__inner">
                <el-button class="selector-action-btn" type="text"
                    :disabled="!currentSelectableItems.length || isCurrentViewAllSelected"
                    @click="selectAllCurrentItems">全选</el-button>
                <span class="selector-actions__divider"></span>
                <el-button class="selector-action-btn" type="text"
                    :disabled="!currentSelectableItems.length || !hasCurrentSelection"
                    @click="clearCurrentItems">全部取消</el-button>
            </div>
        </div>
        <div class="chat-selector">
            <div class="left-box">
                <el-input placeholder="搜索" v-model="searchText" size="small">
                    <i class="el-icon-search el-input__icon" slot="suffix"> </i>
                </el-input>
                <tabs :items="tabItems" :current="tabIdx" @change="onTabChange"></tabs>
                <virtual-scroller v-if="currentTabType == 'chat'" class="left-scroll-box" :items="showChats">
                    <template v-slot="{ item }">
                        <div class="chat-item" @click="onClickChatItem(item)">
                            <head-image :url="item.headImage" :name="item.showName" :size="42" :group="group"></head-image>
                            <div class="chat-info">
                                <div class="chat-name">
                                    <div class="chat-name-text"> {{ item.showName }}</div>
                                    <!-- <div v-if="item.companyName" class="company-tag-mini">@{{ item.companyName }} </div> -->
                                    <el-tag v-if="item.type == 'GROUP'" type="primary">群</el-tag>
                                </div>
                                <div class="chat-content"
                                    v-html="$emo.transform($str.html2Escape(item.lastContent), 'emoji-small')">
                                </div>
                            </div>
                            <el-checkbox v-model="item.checked" class="check-box" @click.native.stop=""
                                @change="onChatChange(item)"></el-checkbox>
                        </div>
                    </template>
                </virtual-scroller>
                <virtual-scroller v-if="currentTabType == 'friend'" class="left-scroll-box" :items="showFriends">
                    <template v-slot="{ item }">
                        <friend-item :menu="false" :friend="item" size="small" @click.native="onClickFriendItem(item)">
                            <el-checkbox v-model="item.checked" class="check-box" @click.native.stop=""
                                @change="onFriendChange(item)"></el-checkbox>
                        </friend-item>
                    </template>
                </virtual-scroller>
                <virtual-scroller v-if="currentTabType == 'group'" class="left-scroll-box" :items="showGroups">
                    <template v-slot="{ item }">
                        <group-item :group="item" :menu="false" size="small" @click.native="onClickGroupItem(item)">
                            <el-checkbox v-model="item.checked" class="check-box" @click.native.stop=""
                                @change="onGroupChange(item)"></el-checkbox>
                        </group-item>
                    </template>
                </virtual-scroller>
            </div>
            <div class="arrow el-icon-d-arrow-right"></div>
            <div class="right-box">
                <div class="tip">已勾选{{ checkedItems.length }}个联系人</div>
                <el-scrollbar class="right-scroll-box">
                    <div v-for="(item, idx) in checkedItems" :key="idx">
                        <div class="checked-item">
                            <head-image :url="item.headImage" :name="item.showName" :size="36" :group="group"></head-image>
                            <div class="chat-name">
                                <div class="chat-name-text">{{ item.showName }}</div>
                                <!-- <div v-if="item.companyName" class="company-tag-mini"> @{{ item.companyName }}</div> -->
                            </div>
                            <div class="close" title="移除" @click.stop="onRemoveItem(item)"><i class="el-icon-close"></i>
                            </div>
                        </div>
                    </div>
                </el-scrollbar>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="close()">取 消</el-button>
            <el-button type="primary" @click="ok()">发 送</el-button>
        </span>
    </el-dialog>
</template>
<script>
import HeadImage from '../common/HeadImage.vue';
import Tabs from '../common/Tabs.vue';
import VirtualScroller from '../common/VirtualScroller.vue';
import FriendItem from '../friend/FriendItem.vue';
import GroupItem from '../group/GroupItem.vue';

export default {
    components: { VirtualScroller, HeadImage, Tabs, FriendItem, GroupItem },
    name: "chatSelector",
    props: {
        title: {
            type: String,
            default: ""
        },
        // 新增group属性，类型为Object
        group: {
            type: Object,
            default: null
        },
        // 新增hideRecentChats属性，控制是否隐藏最近聊天选项卡
        hideRecentChats: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            show: false,
            searchText: "",
            callback: null,
            tabIdx: 0,
            chats: [],
            friends: [],
            groups: [],
            checkedItems: []
        }
    },
    methods: {
        open(callback) {
            this.tabIdx = this.hideRecentChats ? 0 : 0; // 如果隐藏了最近聊天，tabIdx还是0（对应好友）
            this.searchText = "";
            this.show = true;
            this.callback = callback;
            this.initData();
        },
        initData() {
            this.checkedItems = []
            this.chats = [];
            this.friends = [];
            this.groups = []
            this.chatStore.chats.forEach(chat => {
                // 过滤掉掉已经删除好友关系或者退群的会话
                if ((chat.type == 'PRIVATE' && this.friendStore.isFriend(chat.targetId))
                    || (chat.type == 'GROUP' && this.groupStore.isGroup(chat.targetId))) {
                    this.chats.push({
                        type: chat.type,
                        targetId: chat.targetId,
                        headImage: chat.headImage,
                        showName: chat.showName,
                        lastContent: chat.lastContent,
                        companyName: chat.companyName,
                        checked: false
                    })
                }
            })
            this.friendStore.friends.forEach(friend => {
                if (!friend.deleted) {
                    this.friends.push({
                        id: friend.id,
                        headImage: friend.headImage,
                        showNickName: friend.showNickName,
                        companyName: friend.companyName,
                        checked: false
                    })
                }
            })
            this.groupStore.groups.forEach(group => {
                if (!group.quit) {
                    this.groups.push({
                        id: group.id,
                        headImage: group.headImage,
                        headImageThumb: group.headImageThumb,
                        showGroupName: group.showGroupName,
                        checked: false
                    })
                }
            })
        },
        close() {
            this.show = false;
        },
        ok() {
            this.close();
            this.callback(this.checkedItems);
        },
        onTabChange(idx) {
            this.tabIdx = idx;
            // 更新选中状态
            this.chats.forEach(chat => {
                chat.checked = this.checkedItems.some(chatItem => chat.type == chatItem.type && chat.targetId == chatItem.targetId);
            })
            this.friends.forEach(f => {
                f.checked = this.checkedItems.some(chatItem => chatItem.type == 'PRIVATE' && chatItem.targetId == f.id);
            })
            this.groups.forEach(g => {
                g.checked = this.checkedItems.some(chatItem => chatItem.type == 'GROUP' && chatItem.targetId == g.id);
            })
        },
        onClickChatItem(chatItem) {
            chatItem.checked = !chatItem.checked;
            this.onChatChange(chatItem);
        },
        onChatChange(chatItem) {
            this.syncCheckedItem(chatItem, chatItem.checked, chatItem)
        },
        onClickFriendItem(friend) {
            friend.checked = !friend.checked;
            this.onFriendChange(friend);
        },
        onFriendChange(friend) {
            let chatItem = {
                targetId: friend.id,
                type: 'PRIVATE',
                showName: friend.showNickName,
                headImage: friend.headImage,
                companyName: friend.companyName
            }
            this.syncCheckedItem(chatItem, friend.checked, chatItem)
        },
        onClickGroupItem(group) {
            group.checked = !group.checked;
            this.onGroupChange(group);
        },
        onGroupChange(group) {
            let chatItem = {
                targetId: group.id,
                type: 'GROUP',
                showName: group.showGroupName,
                headImage: group.headImageThumb
            }
            this.syncCheckedItem(chatItem, group.checked, chatItem)
        },
        syncCheckedItem(target, checked, payload) {
            let idx = this.checkedItems.findIndex(chat => chat.type == target.type && chat.targetId == target.targetId);
            if (checked) {
                if (idx >= 0) {
                    this.$set(this.checkedItems, idx, payload)
                } else {
                    this.checkedItems.push(payload)
                }
                return;
            }
            if (idx >= 0) {
                this.checkedItems.splice(idx, 1)
            }
        },
        selectAllCurrentItems() {
            this.currentSelectableItems.forEach(item => {
                if (item.checked) {
                    return;
                }
                item.checked = true;
                if (this.currentTabType == 'chat') {
                    this.onChatChange(item);
                } else if (this.currentTabType == 'friend') {
                    this.onFriendChange(item);
                } else {
                    this.onGroupChange(item);
                }
            })
        },
        clearCurrentItems() {
            this.currentSelectableItems.forEach(item => {
                if (!item.checked) {
                    return;
                }
                item.checked = false;
                if (this.currentTabType == 'chat') {
                    this.onChatChange(item);
                } else if (this.currentTabType == 'friend') {
                    this.onFriendChange(item);
                } else {
                    this.onGroupChange(item);
                }
            })
        },
        onRemoveItem(chatItem) {
            let idx = this.checkedItems.findIndex(chat => chat.type == chatItem.type && chat.targetId == chatItem.targetId);
            this.checkedItems.splice(idx, 1);
            // 取消选中状态
            let chat = this.chats.find(chat => chat.type == chatItem.type && chat.targetId == chatItem.targetId);
            if (chat) {
                chat.checked = false;
            }
            if (chatItem.type == 'PRIVATE') {
                let friend = this.friends.find(f => f.id == chatItem.targetId);
                if (friend) {
                    friend.checked = false;
                }
            }
            if (chatItem.type == 'GROUP') {
                let group = this.groups.find(g => g.id == chatItem.targetId);
                if (group) {
                    group.checked = false;
                }
            }
        }
    },
    computed: {
        showChats() {
            return this.chats.filter(chat => chat.showName.includes(this.searchText))
        },
        showFriends() {
            return this.friends.filter(f => f.showNickName.includes(this.searchText))
        },
        showGroups() {
            return this.groups.filter(g => g.showGroupName.includes(this.searchText))
        },
		tabItems() {
		    // 根据hideRecentChats属性决定是否包含最近聊天选项卡
		    if (this.hideRecentChats) {
		        return ['好友'];
		    }
		    return ['最近聊天', '好友', '群聊'];
		},
        currentTabType() {
            if (this.hideRecentChats) {
                return 'friend'
            }
            return ['chat', 'friend', 'group'][this.tabIdx] || 'chat'
        },
        currentSelectableItems() {
            if (this.currentTabType == 'chat') {
                return this.showChats
            }
            if (this.currentTabType == 'friend') {
                return this.showFriends
            }
            return this.showGroups
        },
        isCurrentViewAllSelected() {
            return this.currentSelectableItems.length > 0 && this.currentSelectableItems.every(item => item.checked)
        },
        hasCurrentSelection() {
            return this.currentSelectableItems.some(item => item.checked)
        }
    }
}
</script>

<style scoped lang="scss">
.selector-actions {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    height: 44px;
    padding: 0 0 10px;

    &__inner {
        display: inline-flex;
        align-items: center;
        height: 34px;
        padding: 0 10px;
        border: 1px solid #ebeef5;
        border-radius: 17px;
        background: #f7f8fc;
        box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.85);
    }

    &__divider {
        width: 1px;
        height: 14px;
        margin: 0 4px;
        background: #dcdfe6;
        flex-shrink: 0;
    }

    .selector-action-btn {
        min-width: 60px;
        height: 28px;
        padding: 0 10px;
        border-radius: 14px;
        color: #4c57d6;
        font-size: 13px;
        transition: background-color 0.2s ease, color 0.2s ease;

        &:hover,
        &:focus {
            background: rgba(76, 87, 214, 0.08);
            color: #3f49c9;
        }

        &.is-disabled,
        &.is-disabled:hover,
        &.is-disabled:focus {
            background: transparent;
            color: #b8bcc8;
        }
    }

    ::v-deep .el-button {
        padding: 0;
        margin: 0;
    }
}

.chat-selector {
    display: flex;

    .left-box {
        width: 48%;
        overflow: hidden;
        border: var(--im-border);

        .left-scroll-box {
            height: 400px;

            .check-box {
                margin-right: 10px;
            }

            .chat-item {
                display: flex;
                align-items: center;
                padding: 5px 10px;
                cursor: pointer;

                .chat-info {
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                    padding: 0 10px;
                    text-align: left;
                    overflow: hidden;

                    .chat-name {
                        flex: 1;
                        display: flex;
                        align-items: center;

                        .chat-name-text {
                            font-size: var(--im-font-size);
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                        }
                    }

                    .chat-content {
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        font-size: var(--im-font-size-small);
                        color: var(--im-text-color-light);
                    }
                }

                &:hover {
                    background-color: var(--im-background-active);
                }
            }
        }
    }

    .arrow {
        display: flex;
        align-items: center;
        font-size: 20px;
        padding: 10px;
        color: var(--im-color-primary);
    }

    .right-box {
        width: 48%;
        border: var(--im-border);

        .tip {
            text-align: left;
            height: 32px;
            line-height: 32px;
            text-indent: 10px;
            color: var(--im-text-color-light)
        }

        .right-scroll-box {
            height: 460px;

            .checked-item {
                display: flex;
                align-items: center;
                padding: 5px 10px;
                white-space: nowrap;
                cursor: pointer;


                .chat-name {
                    flex: 1;
                    display: flex;
                    align-items: center;
                    padding: 0 10px;

                    .chat-name-text {
                        font-size: var(--im-font-size);
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }
                }

                .close {
                    width: 30px;
                    display: none;
                }

                &:hover {
                    background-color: var(--im-background-active);
                }

                &:hover .close {
                    display: block;
                }
            }
        }
    }
}
</style>
